import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from "prop-types";
import PromptLight from './../../assets/font/Prompt-Light.woff2';

const Prompt = {
    fontFamily: 'PromptLight',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
    local('PromptLight'), 
    url(${PromptLight}) format('woff2')
  `,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 2px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        fontFamily: Prompt,
    },
    iconButton: {
        padding: 3,
    },
    title: {
        padding: 3,
    },
    divider: {
        height: 28,
        margin: 2,
    },
}));

export default function CustomInputSearch(props) {
    const classes = useStyles();

    const [state, setState] = React.useState({ inputData: "" })

    const onKeyDown = (e) => {
        console.log(e)
    }
    return (
        <Paper component="form" className={classes.root}>
            <span className={classes.title} aria-label="title">
                {props.title}
            </span>
            <InputBase
                className={classes.input}
                placeholder={props.placeholder}
                inputProps={{ 'aria-label': props.placeholder }}
                onChange={e => setState((prevState) => ({
                    ...prevState,
                    inputData: e.target.value
                }))}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        props.handelKeyDown(state.inputData)
                    }

                }}
            />
            <IconButton
                //type="submit" 
                className={classes.iconButton} aria-label="search"
                onClick={() => props.handelClickButton(state.inputData)}
            >
                <SearchIcon />
            </IconButton>
            {/* <Divider className={classes.divider} orientation="vertical" />  */}
        </Paper>
    );
}
CustomInputSearch.propTypes = {
    placeholder: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string
}
